import { Injectable, inject } from '@angular/core';

import { SsrService } from '@services/ssr.service';

@Injectable({
  providedIn: 'root',
})
export class ScrolltoService {
  private ssrService = inject(SsrService);

  scrollTo(scrollto: string | undefined, type?: 'smooth' | 'instant'): void {
    if (this.ssrService.isServer() || !scrollto) return;
    setTimeout(() => {
      if (scrollto === 'top') {
        window.scroll({ behavior: type ?? 'smooth', top: 0 });
      } else {
        const element: HTMLElement | null = document.getElementById(scrollto);
        let headerHeight: number = 102;
        const headerEl: HTMLElement | null = document.querySelector('.header__main');
        if (headerEl) headerHeight = headerEl.getBoundingClientRect().height;
        const offsetY: number = headerHeight + 80;
        if (element) window.scroll({ behavior: type ?? 'smooth', top: element.getBoundingClientRect().top + window.scrollY - offsetY });
      }
    }, 100);
  }
}
